import React from 'react';
import { ValidatedAIResponse } from '../../../ai/responseSchema';

export function PrevThesisBlock({ prev, cur }: { prev: ValidatedAIResponse; cur: ValidatedAIResponse }) {
  const convDelta  = cur.conviction - prev.conviction;
  const deltaColor = convDelta > 0 ? 'var(--green)' : convDelta < 0 ? 'var(--red)' : 'var(--blue-dim)';
  return (
    <div style={{ padding: '10px 12px', background: 'var(--surface)', border: '1px solid var(--border)',
      borderLeft: '3px solid var(--blue-dim)', borderRadius: '0 6px 6px 0', marginBottom: 10, opacity: .75 }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 5, alignItems: 'center' }}>
        <span style={{ fontSize: 9, color: 'var(--blue-dim)', fontFamily: 'var(--mono)', fontWeight: 700 }}>PRIOR THESIS</span>
        <span style={{ fontSize: 9, color: 'var(--blue-dim)', fontFamily: 'var(--mono)' }}>
          {new Date(prev.timestamp).toLocaleTimeString()} · {prev.conviction}% conviction
        </span>
        {convDelta !== 0 && (
          <span style={{ fontSize: 9, color: deltaColor, fontFamily: 'var(--mono)', fontWeight: 700 }}>
            {convDelta > 0 ? '+' : ''}{convDelta}%
          </span>
        )}
      </div>
      <div style={{ fontSize: 11, color: 'var(--blue-muted)', lineHeight: 1.6 }}>{prev.primaryThesis}</div>
      {prev.invalidation && (
        <div style={{ fontSize: 10, color: 'var(--red)', marginTop: 5 }}>
          <span style={{ fontFamily: 'var(--mono)', fontWeight: 700 }}>Was invalidated by: </span>{prev.invalidation}
        </div>
      )}
    </div>
  );
}
